import { Link } from "react-router-dom";
import clip from "../assets/images/clip.svg"
import { formatDate } from "../services/formatDate";
import { READ } from "../services/consts";

function CardItem({post}) {
    return(
        <Link to={READ.substring(0, READ.length - 3) + post.id} className="card-item">
            <div className="clips">
                <img className="clip" src={clip} alt="clip"/>
                <img className="clip_second" src={clip} alt="clip" />
            </div>
            <div className="pattern">
                <h3 className="card-item__title">{post.content.length > 25 ? post.content.substring(0, 25) + ".." : post.content}</h3>
                <span className="card-item__date">{formatDate(post.created_at)}</span>
            </div>
        </Link>
    );
}

export default CardItem;